import { useTranslation } from '@crehana/i18n';

import { HEADER_TRANSLATION_KEY } from '../constants';
import localeEs from '../i18n/localeEs';
import localePt from '../i18n/localePt';

const translations = {
  es: localeEs.es,
  pt: localePt.pt,
};

function useHeaderTranslation() {
  const { addResourceBundle, ...rest } = useTranslation(HEADER_TRANSLATION_KEY);

  addResourceBundle(translations, { injectOnce: true });

  return rest;
}

export default useHeaderTranslation;
